'use client'

import { usePathname } from 'next/navigation'
import { useEffect } from 'react'

import { applyTheme, resolveTheme } from '@/lib/theme/theme-init'

/**
 * Keeps `<html>`'s theme class in step with the route.
 *
 * Two jobs, both about the exempt routes (`/read/*` and `/admin`, which fix
 * their own appearance — see `theme-init`):
 *
 * 1. Entering one from a dark app strips `.dark`, so that surface's own palette
 *    is the only thing colouring the screen.
 * 2. Leaving it restores the stored preference.
 *
 * A *direct* load of an exempt route is handled earlier, by the init script —
 * this effect only runs after hydration, far too late to prevent a flash.
 *
 * Renders nothing; it exists for the effect.
 */
export function ThemeRouteGuard() {
  const pathname = usePathname()

  useEffect(() => {
    applyTheme(resolveTheme(pathname))
  }, [pathname])

  return null
}
